module.exports = __webpack_public_path__ + "img/Profil_TailWing_II_VP-Standard_Standard.b4870076.jpg";